import { countryData } from './countryData';
// Get country name by code for the given language.
//
// The country code is not strongly typed to CountryCode to enable
// the caller to use a data source typed as string (such as the database).
//
// To avoid the need for wrapper functions in case of nulls or invalid codes
// at the caller, the values are accepted but simply return null.
export const getCountryNameByCountryCode = (countryCode, language) => {
    if (!countryCode) {
        return null;
    }
    const countryCodeNormalized = countryCode.trim().toUpperCase();
    if (!valueIsValidCountryCode(countryCodeNormalized)) {
        return null;
    }
    return countryData[countryCodeNormalized].countryName[language] ?? null;
};
const valueIsValidCountryCode = (value) => value in countryData;
//# sourceMappingURL=utils.js.map